import React from 'react'

const InputMobile = ({name,value,type,onChange}) => {
    return(

        <div className='container_inputs_mobile'>

        {type != "textArea" 
        
        ?
        <label>{name}</label>
        :
        <></>
        }
        <input type='text' value={value} onChange={onChange} className='input_mobile' />
  
        </div>

    )
}

export default InputMobile